import type {
  ITextFilter,
  ListingsAPIAndFilter,
  ListingsAPIOrFilter,
} from '@noths/polaris-client-listings-api';

/** @deprecated avoid use of category ID as in future listing queries should be based on attributes */
export const getCategoryIdFromCanonicalFilters = (
  canonicalFilters?: ListingsAPIAndFilter | ListingsAPIOrFilter,
): number | null => {
  if (!canonicalFilters || !('and' in canonicalFilters)) {
    return null;
  }

  const categoryFilter = canonicalFilters.and.find(
    (filter): filter is ITextFilter =>
      'key' in filter && 'text' in filter && filter.key === 'attributes.category_ids',
  );

  const categoryId = parseInt(categoryFilter?.text[0] || '', 10);

  return isNaN(categoryId) ? null : categoryId;
};
